export default __webpack_public_path__ + "static/media/avatar_yellow.6a385f45.svg";